import { Button, Card, CardActionArea, CardContent, Divider, Stack } from "@mui/material";
import React, { ReactChild } from "react";
import { StoreData } from "../../Objects/StoreInterface";
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";
import LabelItem from "../atoms/LabelItem";
import StoreCloseDate from "../atoms/StoreCloseDate";
import StoreLoginName from "../atoms/StoreLoginName";
import StoreName from "../atoms/StoreName";
import StoreOpenDate from "../atoms/StoreOpenDate";
import StoreUnitTime from "../atoms/StoreUnitTime";
import StorePasswordEditDialog from "../organisms/StorePasswordEditDialog";
import StoreSettingEditDialog from "../organisms/StoreSettingEditDialog";

export interface StoreDetailCardProps {
    storeData: StoreData
    onClick?: (storeData: StoreData) => void | undefined
    footMenu?: React.ReactNode
    enableEdit?: boolean
    onEdit?: () => void
}

const StoreDetailCard: React.FC<StoreDetailCardProps> = ({
    storeData,
    onClick,
    footMenu,
    enableEdit,
    onEdit,
}) => {
    const { userObjectState } = React.useContext(UserObjectStore)
    let [content, setContent] = React.useState<ReactChild>()

    const [edit, setEdit] = React.useState<boolean>(false)
    const [changePass, setChangePass] = React.useState<boolean>(false)

    React.useEffect(() => {
        setContent(
            <CardContent>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <StoreName storeData={storeData} />
                </Stack>
                <Divider sx={{ my: 1}}/>
                <LabelItem
                    title="ログイン名"
                >
                    <StoreLoginName storeData={storeData} />
                </LabelItem>
                {storeData.str_unit &&
                    <LabelItem
                        title="1コマの時間数"
                    >
                        <StoreUnitTime storeData={storeData} />
                    </LabelItem>
                }
                {storeData.str_open_date &&
                    <LabelItem
                        title="営業開始日"
                    >
                        <StoreOpenDate storeData={storeData} />
                    </LabelItem>
                }
                {storeData.str_close_date &&
                    <LabelItem
                        title="営業終了日"
                    >
                        <StoreCloseDate storeData={storeData} />
                    </LabelItem>
                }
                {(enableEdit && userObjectState.stfAccessList.includes("StoreSetting")) &&
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        sx={{
                            mt: 1.5
                        }}
                    >
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                setChangePass(true)
                            }}
                        >パスワード変更</Button>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                setEdit(true)
                            }}
                        >編集</Button>
                    </Stack>
                }
            </CardContent>
        )
    }, [storeData, enableEdit, userObjectState.stfAccessList])

    return (
        <>
            <Card variant="outlined" sx={{height: "100%"}}>
                {onClick ? (
                    <CardActionArea
                        onClick={() => {
                            if (onClick) {
                                onClick(storeData)
                            }
                        }}
                    >{content}</CardActionArea>
                ) : (content)}
                {footMenu}
            </Card>
            <StoreSettingEditDialog
                storeId={edit ? storeData.str_id : undefined}
                onClose={(isEdit) => {
                    setEdit(false)
                    if( isEdit && onEdit ) {
                        onEdit()
                    }
                }}
            />
            <StorePasswordEditDialog
                storeId={changePass ? storeData.str_id : undefined}
                onClose={(isEdit) => {
                    setChangePass(false)
                    if( isEdit && onEdit ) {
                        onEdit()
                    }
                }}
            />
        </>
    )
}

export default StoreDetailCard